<template>
  <div class="">
    <popup :has_header="true" v-on:close="closeBox" :show="showTradePassword" class="secondary-wrapper" @on-shown="onShown">
      <div slot="popup-body" class="secondary-body">
        <div class="title">
          <h2 v-if="!isReset">请输入交易密码</h2>
          <h2 v-else>重置交易密码</h2>
          <span class="line"></span>
        </div>
        <div class="content" v-show="!isReset">
          <p class="content-text">你的帐号设置了“交易密码”，请输入正确的密码以完成交易</p>
          <input type="text" class="content-input" name="" value="" placeholder="请输入交易密码" v-model="pwd" onfocus="this.type='password'" v-on:keyup.enter="submitSecondary" autofocus maxlength="6">
          <button class="content-button" @click="submitSecondary">
            提交
          </button>
          <div class="content-footer" @click="forgetPwd">
            忘记密码？
          </div>
        </div>
        <div class="content reset" v-show="isReset">
          <p class="content-text">该操作将重置你的交易密码，请选择以下任意一种接收方式！</p>
          <div class="content-btn-group">
            <a href="javascript:;" class="btn-item" :class="{'active':resetType=='phone'&&hasPhone,'hastip':!hasPhone}" @click="setResetType('phone')">
              手机短信<span class="tips" v-if="!hasPhone">您还未绑定手机</span>
            </a>
            <a href="javascript:;" class="btn-item" @click="setResetType('email')" :class="{'active':resetType=='email','hastip':!hasEmail}">
              电子邮箱<span class="tips" v-if="!hasEmail">您还未绑定邮箱</span>
            </a>
          </div>
          <p class="content-info" v-if="sendSuccess">
            {{tipText}}发送成功，请查收
          </p>
          <div class="content-button reset" @click="resetPwd" v-if="count.current==count.countDuring">
            立即重置
          </div>
          <div class="content-button reset wait" v-else>
            {{count.current}}s后重新发送
          </div>
          <div class="content-footer" @click="isReset=false">
            返回
          </div>
        </div>
      </div>
    </popup>
    <v-alert :options="options"></v-alert>
  </div>
</template>

<script type="text/javascript">
  import popup from "./popup.vue"
  import vAlert from "./alert.vue"


  export default {
    props: {
      showTradePassword: {
        default: false
      },
      hasEmail: {
        default: false
      },
      hasPhone: {
        default: true
      }
    },
    data() {
      return {
        isReset: false,   // 是否忘记密码
        pwd: '',
        resetType: 'phone',
        tipText: '',
        sendSuccess: false,
        count: {
          timer: 0,
          countDuring: 60,
          current: 60
        },
        options: {   // 消息弹窗
          msgText: "",
          msgIsSuccess: true
        },
        localShow: false
      }
    },

    methods: {
      /*
        忘记密码
      */
      forgetPwd() {
        this.isReset = true;
        this.pwd = '';
      },
      /*
        关闭弹窗
      */
      closeBox() {
        this.show = false;
        this.$emit('close-box')
        // this.$store.commit("hideSecondary");
        // smart.logout(logout_callback);
        //pt_logout.logout(logout_callback);
      },
      /*
        设置重置密码类型
        type: 类型  phone/email
      */
      setResetType(type) {
        if (type === 'email' && !this.hasEmail) {
          return ;
        }
        this.resetType = type;
      },
      /*
        立即重置密码
      */
      resetPwd() {
        if (this.resetType == 'phone') {
          this.tipText = "短信"
        }else {
          this.tipText = "邮件"
        }
        this.count.current--;
        this.count.timer = setInterval(() => {
          this.count.current--;
          if (this.count.current <= 0) {
            clearInterval(this.count.timer);
            this.count.current = this.count.countDuring;
          }
        }, 1000)
        axios.post(myUrl + "login/extra/reset/", qs.stringify({
          type: this.resetType,
          password_type: 'trade'
        })).then((res) => {
          res = res.data;
          if (res.result) {
            this.sendSuccess = true;
          }else {
            this.options = {
              msgText: res.message.replace(/\s[\x00-\xff]*/g,''),
              msgIsSuccess: false
            }
          }
        })
      },
      /*
        提交二级密码
      */
      submitSecondary() {
        if (this.pwd == '' || this.pwd == null) {
          this.options = {
            msgText: '交易密码不能为空',
            msgIsSuccess: false
          }
        }
        else {
          axios.post(myUrl + "market/gift/check_trade_password/", qs.stringify({
            'trade_password': this.pwd
          })).then((res) => {
            res = res.data;
            if (res.result) {
              this.$emit("after-check",this.pwd)
            }else {
              this.options = {
                msgText: res.message.replace(/\s[\x00-\xff]*/g,''),
                msgIsSuccess: false
              }
            }
          })
        }
      },
      onShown () {
        // console.log('onshown')
        this.$nextTick(() => {
          this.localShow = true
        })
      }
    },
    components: {
      popup,
      vAlert
    },
    mounted() {
      // window.test = this.$refs.input
      // this.$refs.input.focus();
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  @import '../scss/conf.scss';
  .secondary-wrapper{
    .secondary-body{
      width: 735px;
      height: 466px;
      .title{
        text-align:center;
        h2{
          font-size: 30px;
          font-weight:normal;
        }
        .line{
          display:block;
          width: 30px;
          height: 2px;
          margin:15px auto 0;
          background: $bkBlue;
        }
      }
      .content{
        position: relative;
        margin-top: 58px;
        text-align: center;
        font-size: 18px;
        .content-text{
          line-height: 18px;
          color: #666;
        }
        .content-input{
          margin-top: 60px;
          margin-bottom: 38px;
          width: 420px;
          height: 42px;
          border: 1px solid #d9d9d9;
          font-size: 14px;
          border-radius: 3px;
          text-align: center;
        }
        ::-ms-input-placeholder{
          text-align: center;
        }
        ::-webkit-input-placeholder{
          text-align: center;
        }
        ::-moz-placeholder{
          text-align: center;
        }
        .content-button{
          width: 240px;
          height: 56px;
          background: $bkBlue;
          color: #fff;
          line-height: 56px;
          border-radius: 56px;
          margin: 0 auto;
          cursor: pointer;
          display: block;
          border: none;
          outline: none;
          &:hover{
            background: $bkHover;
          }
          &.reset{
            background: #ffc349;
            &.wait{
              cursor: default;
              background: #ffdb92;
              &:hover{
                background: #ffdb92;
              }
            }
            &:hover{
              background: #ffb726;
            }
          }
        }
        .content-footer{
          display: inline-block;
          margin-top: 50px;
          font-size: 14px;
          color: $bkBlue;
          cursor: pointer;
          user-select: none;
        }
        &.reset{
          .content-btn-group{
            margin-top: 38px;
            margin-bottom: 70px;
            font-size: 0;
            .btn-item{
              display: inline-block;
              font-size: 14px;
              width: 92px;
              height: 32px;
              line-height: 32px;
              border-radius: 3px;
              color: #666;
              background: #f6f6f6;
              &.active{
                background: $bkBlue;
                color: #fff;
              }
              &.hastip{
                position: relative;
                cursor: default;
                &:hover{
                  .tips{
                    display: block;
                  }
                }
                .tips{
                  display: none;
                  background: #090b1a;
                  position: absolute;
                  top: -40px;
                  left: -14px;
                  width: 120px;
                  height: 30px;
                  line-height: 30px;
                  border-radius: 2px;
                  text-align: center;
                  color: #fff;
                  &:after{
                    content: '';
                    position: absolute;
                    left: 50%;
                    bottom: -14px;
                    width: 0;
                    height: 0;
                    border: 10px solid #090b1a;
                    border-color: #090b1a transparent transparent transparent;
                    margin-left: -10px;
                  }
                }
              }
            }
            .btn-item:first-child{
              margin-right: 10px;
            }
          }
          .content-info{
            position: absolute;
            font-size: 12px;
            color: #666;
            left: 50%;
            top: 114px;
            transform: translateX(-50%);
            -o-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            -webkit-transform: translateX(-50%);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// transaction.vue?14a40592